<template>
    <div class="bg-white border border-gray-700 m-4">
        <div class="flex justify-between">
            <div class="p-4 w-2/3">
                <div class="text-gray-900 font-bold text-xl mb-2">{{ referral.name }}</div>
                <p v-if="canResendEmail" class="text-gray-700 text-base">
                    {{ $t('CARD_INVITE_STILL') }} {{ referral.name }}.
                </p>
                <p v-else-if="referral.signed_up_date" class="text-gray-700 text-base">
                    {{ $t('CARD_INVITE_INVITE_ACCEPTED') }}
                </p>
                <p v-else>
                    {{ $t('CARD_INVITE_INVITE_SENT') }}
                </p>
            </div>
            <div v-if="canResendEmail" class="p-4">
                <img class="h-20" :src="flowersImage">
            </div>
            <div v-else-if="referral.signed_up_date"
                 class="freeFlowers__dateBox w-30 h-20">
                <p class="m-0" v-text="referral.signed_up_date_name"/>
                <p class="text-4xl m-1">{{ referral.signed_up_date|formatDate(0, 2) }}</p>
                <p class="m-0">{{ referral.signed_up_date|formatDate(5, 3) }}</p>
            </div>
            <div v-else class="p-4">
                <img class="h-20" :src="flowersImage">
            </div>
        </div>
        <div v-if="canResendEmail">
            <a @click.prevent="updateReferral"
               class="flex border-t border-grey-500 cursor-pointer">
                <div class="flex item-center px-4 py-2 text-sm">
                    <img class="h-8" src="@/assets/images/decoration/loading-icon.svg">
                    <p class="pl-2 text-gray-900 leading-none" v-text="$t('CARD_INVITE_RESEND_INVITE')"></p>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import ReferralService from '@/services/users/ReferralService';
import Image from '@/assets/images/pages/faq/icons/free-flowers.png';

export default {
    name: 'CardInvite',
    data() {
        return {
            flowersImage: Image,
        };
    },
    props: {
        referral: {
            required: true,
            type: Object,
        },
    },
    computed: {
        canResendEmail() {
            return this.referral.can_resend_email;
        },
    },
    filters: {
        formatDate(value, start, length) {
            return value.substr(start, length);
        },
    },
    methods: {
        /**
         * Resend the invite.
         *
         * @param {Number} id
         *
         * @returns {void}
         */
        updateReferral() {
            const referralService = new ReferralService();

            referralService.updateReferral(this.referral.referral_invite_id)
                .then(() => {
                    this.$emit('invite-updated');
                })
                .catch(error => {
                    console.error(error);
                });
        },
    },
};
</script>
